<template>
  <view-layout v-bind="$attrs">
    <v-card tile flat dark class="text-center pa-0 overflow-hidden" color="primary" style="height: 100%; width: 100%; background-color: #201F49; position: fixed;">
      <v-row class="overflow-y-auto" justify="space-between" align="center" style="height: 100%; background-color: var(--v-primary-base); height: 100%">
        <v-col class="px-4 px-0" cols="12" align="center" style="padding-bottom: 180px;">
          <slot name="image"></slot>
          <div class="d-flex flex-column mt-9">
            <slot></slot>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <template slot="footer">
      <div class="pb-6 px-4">
        <slot name="footer"></slot>
      </div>
    </template>
  </view-layout>
</template>
<style>
</style>
<script>
export default {
  data () {
    return {
      model: {},
    };
  },
};
</script>
